import { Attribute } from './Attribute.js';

export const DEVICE_ATTRIBUTE_TYPE = 'DeviceAttribute';
export const DEVICE_NAME_ATTRIBUTE_ID = 'Device Name';
export const IMEI_ATTRIBUTE_ID = 'IMEI';

/**
 * @property {string} name
 * @property {string} imeiCode
 * @property {boolean} isReadOnly
 */
export class DeviceAttribute extends Attribute {
  constructor({ name, imeiCode, isReadOnly = false }) {
    super();
    this.name = name;
    this.imeiCode = imeiCode;
    this.isReadOnly = isReadOnly;
    this.type = DEVICE_ATTRIBUTE_TYPE;
  }
}
